"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:no-use-before-declare */
var _ = require("underscore");
var deferred_1 = require("../deferred");
var sleep_1 = require("../sleep");
// tslint:disable
/**
 * retry decorator
 *
 * @retry()
 */
function retry(config, canRetry) {
    return function (target, key, descriptor) {
        // tslint:disable-next-line:no-parameter-reassignment
        descriptor = descriptor || Object.getOwnPropertyDescriptor(target, key);
        var action = descriptor.value;
        descriptor.value = function () {
            var args = _.map(arguments, function (x) { return x; });
            var _this = this;
            return retryAction(function () {
                try {
                    return action.apply(_this, args);
                }
                catch (ex) {
                    // ignore error
                }
            }, canRetry, config);
        };
        return descriptor;
    };
}
exports.retry = retry;
// tslint:disable-next-line:no-reserved-keywords
function createSequence(type) {
    switch (type) {
        case 'constant':
            return { next: function () { return 1; } };
        case 'exponential': {
            var prev_1 = 0;
            return {
                next: function () {
                    var result = Math.pow(2, prev_1);
                    prev_1++;
                    return result;
                }
            };
        }
        case 'linear': {
            var prev_2 = 0;
            return { next: function () { return ++prev_2; } };
        }
        case 'fibonacci': {
            var prev_3 = 0;
            var cur_1 = 1;
            return {
                next: function () {
                    var result = prev_3 + cur_1;
                    prev_3 = cur_1;
                    cur_1 = result;
                    return result;
                }
            };
        }
        default:
            throw new Error("unknown sequence type " + type);
    }
}
exports.createSequence = createSequence;
var _defaultRetryOption = {
    type: 'constant',
    beat: 200,
    maxDuration: 120000,
    maxInterval: 30000
};
function retryAction(action, canRetry, delay) {
    return __awaiter(this, void 0, void 0, function () {
        var start, _a, type, beat, maxDuration, maxInterval, maxIteration, sequence, invokeCount;
        var _this_1 = this;
        return __generator(this, function (_b) {
            start = new Date().getTime();
            _a = _.extend({}, _defaultRetryOption, delay), type = _a.type, beat = _a.beat, maxDuration = _a.maxDuration, maxInterval = _a.maxInterval, maxIteration = _a.maxIteration;
            sequence = createSequence(type);
            invokeCount = 0;
            return [2 /*return*/, repeat(action, canRetry, function () { return __awaiter(_this_1, void 0, void 0, function () {
                    var now, duration, waitDuration;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                now = new Date().getTime();
                                invokeCount++;
                                duration = now - start;
                                if (maxIteration > 0 && invokeCount >= maxIteration) {
                                    throw new Error("exceeded maxIteration " + maxIteration);
                                }
                                waitDuration = sequence.next() * beat;
                                if (maxInterval > 0) {
                                    waitDuration = Math.min(maxInterval, waitDuration);
                                }
                                if (maxDuration > 0 && duration + waitDuration > maxDuration) {
                                    throw new Error("exceeded maxDuration " + maxDuration);
                                }
                                return [4 /*yield*/, sleep_1.sleep(waitDuration)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); })];
        });
    });
}
exports.retryAction = retryAction;
/**
 * repeat action until it resolves to promise
 * @param action async action that returns a Promise<T>
 * @param canRetry when action rejects with err, check if the error can be retried
 * @param wait wait before issue the next repeat
 */
function repeat(action, canRetry, wait) {
    return __awaiter(this, void 0, void 0, function () {
        var result, inner;
        var _this_1 = this;
        return __generator(this, function (_a) {
            result = deferred_1.createDeferred();
            inner = function () { return __awaiter(_this_1, void 0, void 0, function () {
                var x, innerError_1, waitError_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 10]);
                            return [4 /*yield*/, action()];
                        case 1:
                            x = _a.sent();
                            result.resolve(x);
                            return [3 /*break*/, 10];
                        case 2:
                            innerError_1 = _a.sent();
                            return [4 /*yield*/, canRetry(innerError_1)];
                        case 3:
                            if (!_a.sent()) return [3 /*break*/, 8];
                            _a.label = 4;
                        case 4:
                            _a.trys.push([4, 6, , 7]);
                            return [4 /*yield*/, wait()];
                        case 5:
                            _a.sent();
                            //tslint:disable-next-line:no-floating-promises
                            inner();
                            return [3 /*break*/, 7];
                        case 6:
                            waitError_1 = _a.sent();
                            result.reject(waitError_1);
                            return [3 /*break*/, 7];
                        case 7: return [3 /*break*/, 9];
                        case 8:
                            result.reject(innerError_1);
                            _a.label = 9;
                        case 9: return [3 /*break*/, 10];
                        case 10: return [2 /*return*/];
                    }
                });
            }); };
            //tslint:disable-next-line:no-floating-promises
            inner();
            return [2 /*return*/, result.promise];
        });
    });
}
exports.repeat = repeat;
//# sourceMappingURL=retry.js.map